import { render, staticRenderFns } from "./add-record-dialog.vue?vue&type=template&id=44c671f0&scoped=true"
import script from "./add-record-dialog.vue?vue&type=script&lang=js"
export * from "./add-record-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c671f0",
  null
  
)

export default component.exports